<template>
    <div class="px-6 py-5 overflow-y-auto right-content-grid-vs h-[calc(100vh-309px)]">
        <div class="text-[#414141] font-sans">
            <h3 class="text-[1.25rem] leading-[1.75rem] mb-[1rem] font-semibold">
                Overview
            </h3>
            <p class="text-[14px] leading-[22px] mb-[0.5rem]">A <strong>Strategic Plan for Fundraising</strong> is a clear and compelling plan that organizes and communicates an organization’s work in a way that resonates with funders. Rooted in your organization’s aspirational vision and mission, the plan provides a structured framework for defining core programs, initiatives, funding needs, and budgets. A well-developed plan helps prioritize goals and objectives, align leadership, staff, and key stakeholders, and ensure that fundraising strategies are grounded in sound reasoning. It also fosters operational efficiency, internal alignment, and accountability across the organization. By developing a clear roadmap, the plan builds confidence within the team, supports consistent and repeatable fundraising messaging, and strengthens communication with external audiences, including donors and partners</p>

            <p class="text-[14px] leading-[22px] mb-[0.5rem]">The following modules will help you build your organization's strategic plan for fundraising to ensure you can articulate your organization's current and future work and fundraising goals in a clear, concise, and compelling manner that will resonate with funders.</p>
        </div>
    </div>
</template>

<script setup>
import { useStepValidation } from '@/composables/useStepValidation'; // Import the validation composable

// Use the validation composable with default settings
useStepValidation();
</script>

<style scoped>
</style>